import { useMemo } from "react";
import { Popup } from "react-leaflet";
import { SmoothMarker } from "@/components/dispatch/SmoothMarker";
import { makeVehicleIcon, motionState, fmtClock, fmtDuration, ageSeconds } from "./gpsUtils";

export function UnitGpsMarker({ p, now }) {
  const sec = Math.floor(now / 1000);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const icon = useMemo(() => makeVehicleIcon(p, now), [p, sec]);
  const state = motionState(p, now);
  return (
    <SmoothMarker lat={p.latitude} lng={p.longitude} icon={icon} duration={2000} linear adaptive>
      <Popup>
        <div data-testid={`gps-popup-${p.mapped_unit_name}`} style={{ fontFamily: "'IBM Plex Sans', sans-serif", fontSize: 12 }}>
          <strong>{p.mapped_unit_name}</strong> <span style={{ color: "#666" }}>({p.source})</span><br />
          Status: <b>{state.toUpperCase()}</b><br />
          Speed: {Math.round(p.speed_mph || 0)} MPH<br />
          {p.stopped && p.stopped_since && <>Stopped: {fmtDuration((now - new Date(p.stopped_since).getTime()) / 1000)}<br /></>}
          {p.stop_address && <>At: {p.stop_address}<br /></>}
          Last update: {fmtClock(p.last_update)} ({fmtDuration(ageSeconds(p, now))} ago)
        </div>
      </Popup>
    </SmoothMarker>
  );
}

export function UnitGpsLayer({ positions, now }) {
  return (positions || []).map((p) => <UnitGpsMarker key={p.mapped_unit_id || p.deviceId} p={p} now={now} />);
}
